import { Close } from '@mui/icons-material'
import { Box, Button, Modal } from '@mui/material'
// import MailConnectorSVG from '../../../../../../../../components/svg/mail-conector'
import MailConnectorSVG from '../../../../../../../components/svg/mail-conector'
import { IProjectDTO } from 'data/dtos/automation/i-project-dto'
import api from 'services/api'
import dayjs from 'dayjs'

interface IProps {
  open: boolean
  setChangeState: () => void
  handleClose: () => void
  data: { ultimaAtualizacao: string, isSeller: boolean }
  project: IProjectDTO
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 'auto',
  width: '100%',
  maxWidth: 620,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '1rem',
  border: 'none',
  outline: 'none',
  padding: '24px',
}

const ModalExportSeller = ({ open, setChangeState, handleClose, data, project }: IProps) => {

  const handleExecuteRecipe = async () => {
    try {
      const exportLayoutRecipe = project.recipes.find((recipe) => recipe.recipeName === 'Exportação de arquivo');

      if (!exportLayoutRecipe) return;

      console.log("BBB", exportLayoutRecipe)
      await api.post(`/projects/trigger/${project.id}`, {
        position: exportLayoutRecipe.position
      })
    } catch (error) {
      console.log(error)
    } finally {
      setChangeState()
    }
  }
  return (
    <Modal
      open={open}
      onClose={setChangeState}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <div style={{"display":"flex","justifyContent":"space-between","alignItems":"center"}}>
          <h6 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Gostaria de exportar?</h6>
          <Close
            style={{"cursor":"pointer"}}
            // className='cursor-pointer transition-all duration-300 ease-in-out hover:text-red-500'
            onClick={handleClose}
          />
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '34px', marginTop: '24px' }}>
          <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Dados atualizados em</p>
          <span style={{ fontSize: '14px', lineHeight: '20px', fontWeight: '600', color: '#6F6F78' }}>{dayjs(data.ultimaAtualizacao).format('DD/MM/YYYY HH:mm')}</span>
        </div>

        {data.isSeller && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '34px', marginTop: '24px' }}>
            <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78' }}>Conector de saída</p>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
              <MailConnectorSVG />
              <span style={{ fontSize: '16px' }}>E-mail</span>
            </div>
          </div>
        )}

        <div style={{"display":"flex","paddingTop":"0.5rem","paddingBottom":"0.5rem","marginTop":"1rem","justifyContent":"flex-end","alignItems":"center","width":"100%"}}>
          <div style={{"display":"flex","gap":"0.25rem"}}>
            <Button
              variant='outlined'
              color='error'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              onClick={handleClose}
            >
              Não
            </Button>

            <Button
              variant='contained'
              style={{"paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
              onClick={handleExecuteRecipe}
            >
              Sim, exportar
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default ModalExportSeller
